// ADD A SACHET TO CART
var addSachetToCart = function(variantID){

  var list ='';

  if (typeof template != 'undefined' && template == 'search') {
    list = 'search_result';
  } else {
    list = 'cart';
  }

    $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { quantity: 1, id: variantID },
        success: function(data) {
            if(typeof dataLayer == 'object'){
              dataLayer.push({
                  'event': 'addToCart',
                  'ss_event_id': GTM.getGtmRandomString(),
                  'addType' : 'cart',
                  'ecommerce': {
                  'currencyCode': GTM.currency_code,
                  'add': {
                      'actionField': {

                      'list': list
                      },
                      'products': [{
                      'name': GTM.formatString(data.product_title),
                      'id': data.id,
                      'price': data.price,
                      'brand': GTM.formatString(data.vendor),
                      'category': GTM.formatString(data.product_type),
                      'variant': GTM.formatString(data.variant_title),
                      'quantity': 1
                      }]
                  }
                  }
              });

              /* GTM add_single_dose */

              dataLayer.push({
                  'event': 'GAevent',
				          'ss_event_id': GTM.getGtmRandomString(),
                  'eventID': '14',
                  'eventCategory': 'mini_cart',
                  'eventAction': 'add_single_dose',
                  'eventLabel': GTM.formatString(data.product_title),
                  'sku': data.sku
              });
            }

           $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                success: function(cart) {
                  refreshCart(cart);
                }
            });

        },
        error: function(data) {
            console.log("error");
            console.log(data);
        }
    });
};
// REMOVE A SACHET FROM CART
var removeSachetToCart = function(variantID){

    $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { quantity: 0, id: variantID },
        success: function(data) {
            refreshCart(data);
        },
        error: function(data) {
            console.log("error");
            console.log(data);
        }
    });
};
// UPDATE SACHET QUANTITY
var updateSachetQuantity = function(sachets){
  $.ajax({
    url: '/cart/update.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {updates: sachets},
    success: function(data) {
        refreshCart(data);
    },
    error: function(data) {
        console.log("error");
        console.log(data);
    }
  });
};

let freeshippingLimit = 59 * 100;

// SET PROGRESS BAR
var setProgressBar = function(totalCart) {
  let $mobile_menu_progress = $('.mobile_menu__treshold .cart-shipping__wrapper');

  if (typeof $mobile_menu_progress != 'undefined') {

    let result = Math.min(100, Math.round((100 * totalCart) / freeshippingLimit));
    let remainingAmount = Shopify.formatMoney((freeshippingLimit - totalCart), $('body').data('money-format'));

    if (totalCart >= freeshippingLimit) {
      $('.cart-shipping__success').show();
      $('.cart-shipping__num-outer').hide();
    } else {
      $('.cart-shipping__success').hide();
      $('.cart-shipping__num-outer').show();
      $('.cart-shipping__num').text(remainingAmount);
    }

    $('.cart-shipping-threshold__progress').css('width', result + '%');
    if (totalCart >= freeshippingLimit) {
      $('.cart-shipping-threshold__progress').css('border-radius', '8px');
    } else {
      $('.cart-shipping-threshold__progress').css('border-radius', '8px 0px 0px 8px');
    }

    $('.cart-shipping__wrapper').addClass('visible');
  }
};

// SET DISTANCE FROM FREE SHIPPING
var setFreeShippingDistance = function(totalCart){
  let html_content = "";
  let $mobile_menu_treshold = $('.mobile_menu__treshold .cart_freeshipping .text');

  if( totalCart >= freeshippingLimit ){
    html_content += "<span>Glückwunsch!</span><span>Du erhältst kostenlosen Standardversand</span>";
  }
  else{
    html_content += "<span>Du bist nur " +
                      Shopify.formatMoney((freeshippingLimit - totalCart), $('body').data('money-format')) +
                    " vom kostenlosen Versand entfernt!</span>";
  }
  $('.dav-minicart').each( function(){
    $(this).find('.cart_freeshipping .text').html(html_content);
  });
  if(typeof $mobile_menu_treshold != 'undefined'){
    $mobile_menu_treshold.html(html_content);
  }
};

//SET ON AND OFF TO SACHETS ADDER/REMOVER AND SYNC
var syncSachetsState = function($eventTarget, isChecked) {
  let totalSelected = $eventTarget.closest('.dav-minicart .sachet_list').find('input:checked')
  let limit;

  
    if(logged_in) {
      limit = 3;
    } else {
      limit = 1;
    }
  

  if(window.viptiers_limit != null) {
    limit = window.viptiers_limit;
  }
  
  

  const variantId = $eventTarget.data('variant_id');
  const $inputList = $('.dav-minicart .sachet_list li input[data-variant_id="'+ variantId +'"]');

  $inputList.prop('checked', isChecked);

  $('.dav-minicart .sachet_list li input:not(:checked)').attr('disabled', totalSelected.length >= limit );

};

// UPDATE GLOBAL LIMIT AND SYNC
$('body').on('change', ".dav-minicart .sachet_list li input", function(event) {
  let variant_id = $(this).attr("data-variant_id");

  if (this.checked) {
    addSachetToCart(variant_id);
  } else {
    removeSachetToCart(variant_id);
  }

  syncSachetsState($(event.target), this.checked);
});

//FIRST SETUP OF SACHETS ADDER/REMOVER
var setupSachetsData = function(){
  $.getJSON('/cart.js', function(cart) {
      // now have access to Shopify cart object
      let items = cart.items;
      let sachets_counter = 0;
      let products_counter = 0;
      let virtual_products_counter = 0;
      let sachets_to_update = {};
      let sachets_to_remove = {};
      let physical_products_counter = 0;
      let products_not_counted = 'sachet,promogift';
      let cart_physical_products = 0;
      products_not_counted = products_not_counted.split(',');

      let limit;
      
        if(logged_in) {
          limit = 3;
        } else {
          limit = 1;
        }
      

      if(window.viptiers_limit != null) {
        limit = window.viptiers_limit;
      }
      
      

      Object.values(items).forEach(value => {
        if (value.requires_shipping) {
          physical_products_counter ++;
        } else {
          virtual_products_counter ++;
        }
        if (value.product_type == "sachet"){ // se è un campioncino
          sachets_to_remove[value.variant_id] = 0;
          if (sachets_counter >= limit) {
            sachets_to_update[value.variant_id] = 0;
          } else {
            sachets_counter++;
            // Sincronizza lo stato tra tutte le liste
            $('.dav-minicart .sachet_list li input[data-variant_id="'+ value.variant_id +'"]').prop('checked', true);
          }
        } else if (products_not_counted.indexOf(value.product_type) == -1) {
          products_counter = products_counter + (1 * value.quantity);
        }
      });

      $('.dav-minicart').each( function(){
        $(this).attr("data-products", products_counter).attr("data-sachets", sachets_counter); // segno nei minicart la quantitaì di prodotti e campioncini presenti nel cart
      });

      // hide an empty sachets in case of only virtual products on cart
      if(
        (physical_products_counter == 0 && products_counter > 0) ||
        (virtual_products_counter + sachets_counter == items.length)
        ){
        if(!jQuery.isEmptyObject(sachets_to_remove)) {
          updateSachetQuantity(sachets_to_remove);
        }
        if(items.length > 0){
          $('.sachets, .cart_promo_box').hide();
        } else {
          $('.sachets, .cart_promo_box').show();
        }
      } else {
        $('.sachets, .cart_promo_box').show();
      }

      if ( products_counter < 1 && sachets_counter > 0 ){
        emptyCart(); // svuoti carrello
        setupSachetsData(); // Rivaluto tutto
      }
      else{
        if(!jQuery.isEmptyObject(sachets_to_update)) {
          updateSachetQuantity(sachets_to_update);
        }
        // sistemo i campioncini
        let uniqueVariants = new Set();

        $('.sachet_list li input:checked').each(function() {
          uniqueVariants.add($(this).data('variant_id'));
        });
        // Array of unique values from the input list checked
        let checkedSachet =[...uniqueVariants];
        $('.sachet_list li input:not(:checked)').attr('disabled', checkedSachet.length >= limit );
        // evalChecked();

        

        setFreeShippingDistance( cart.total_price ); // sistemo le spese di spedizione
        setProgressBar(cart.total_price); //update progress bar
      }
  });
};

$('body').on('click', '.remove-sachet-cart_item', function () {
  var $this = $(this),
      $modal = $('#cartModal');

  $modal.modal('show');
  $modal.data('productRemoveButton', $this);

  return false;
});

//EXECUTED EACH TIME ORIGINAL BLOCK IS CALLED
$( document ).on( "originalRefreshCart", function() {
  setupSachetsData(); // Rivaluto tutto
});

var removeSachetGtmPush = function () {

  var list ='';

  if (typeof template != 'undefined' && template == 'search') {
    list = 'search_result';
  } else {
    list = 'cart';
  }

  $.ajax({
    url: '/cart',
      success: function () {

        $('.dav-shoppingbag .sachets .sachet_list li div input[type=checkbox]').click(function () {

          var single_dose_name = $(this).attr('product-title');
          var product_sku = $(this).attr('data-product-sku');
          var variant_id = $(this).attr('data-variant_id');
          var variant_title = $(this).attr('data-variant-title');
          var product_price = $(this).attr('product-price');
          var product_brand = $(this).attr('product-brand');
          var product_type = $(this).attr('product-type');

          if(this.checked != true && typeof dataLayer == 'object'){

            dataLayer.push({
            'event': 'removeFromCart',
            'ss_event_id': GTM.getGtmRandomString(),
            'ecommerce': {
                'currencyCode': GTM.currency_code,
                'remove': {
                'actionField': {
                    'list': list
                },
                'products': [{
                    'name': GTM.formatString(single_dose_name),
                    'id': variant_id,
                    'price': product_price,
                    'brand': GTM.formatString(product_brand),
                    'category': GTM.formatString(product_type),
                    'variant': GTM.formatString(variant_title),
                    'quantity': 1
                }]
                }
            }
            });

            dataLayer.push({
            'event': 'GAevent',
				    'ss_event_id': GTM.getGtmRandomString(),
            'eventID': '15',
            'eventCategory': 'mini_cart',
            'eventAction': 'remove_single_dose',
            'eventLabel': GTM.formatString(single_dose_name),
            'sku': product_sku
            });

          }

        });

      }
  });
}

removeSachetGtmPush();


//EXECUT FIRST SETUP
setupSachetsData();
